module.exports = __webpack_public_path__ + "static/craftsmanLogo-2829a4db463c8ff8c28a999875de695b.jpg";